<script>
import { CellGroup, Cell, Field, DatetimePicker, Toast } from 'vant'
import ImageUploader from '@/components/org/ImageUploader'
import PickerSelector from '@/components/org/PickerSelector'
import DateSelector from '@/components/org/DateSelector'
import ShortcutDateSelector from '@/components/org/ShortcutDateSelector'
import BottomToolbar from '@/components/org/BottomToolbar'
import Organization from '@/tbs/model/to/Organization'
import OrganizationAuthentication from '@/tbs/model/vo/OrganizationAuthentication'
import { QNImageUtil } from '@/utils'

const  organizationAuthentication = new OrganizationAuthentication

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'organization-authentication-info',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell-group': CellGroup,
        'van-cell': Cell,
        'van-field': Field,
        'datetime-picker': DatetimePicker,
        'image-uploader': ImageUploader,
        'picker-selector': PickerSelector,
        'date-selector': DateSelector,
        'shortcut-date-selector': ShortcutDateSelector,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        authentication: Object,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['submit-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            organization: {
                id: null,
                status: null,
                type: null,
                businessFullName: null,
                businessLicencePicUrl: null,
                businessLicencePic: null,
                businessLicenceCode: null,
                businessLicenceStartDate: null,
                businessLicenceEndDate: null,
                credentialType: null,
                credentialFullName: null,
                credentialPicUrl: null,
                credentialPic: null,
                credentialCode: null,
                credentialStartDate: null,
                credentialEndDate: null,
                credentialRegistrationAddress: null,
                userFullName: null,
                userFacePhotoPicUrl: null,
                userFacePhotoPic: null,
                userNationalEmblemPicUrl: null,
                userNationalEmblemPic: null,
                userIndentityCode: null,
                userPhone: null,
                failedMsg: null,
            },
            locale: new Organization
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        organizationTypeOptions() {
            return organizationAuthentication.getOrganizationTypeOptions()
        },
        credentialTypeOptions() {
            return organizationAuthentication.getCredentialTypeOptions()
        },
        isTypeEmpty() {
            return !(this.organization.type)
        },
        isBusinessEdit() {
            if ((this.organization.status == '1' || this.organization.status == '4') 
                && this.organization.type == '1') {
                return true
            }
            return false
        },
        isBusinessReadonly() {
            if ((this.organization.status == '2' || this.organization.status == '3') 
                && this.organization.type == '1') {
                return true
            }
            return false
        },
        isCredentialEdit() {
            if ((this.organization.status == '1' || this.organization.status == '4') 
                && this.organization.type == '2') {
                return true
            }
            return false
        },
        isCredentialReadonly() {
            if ((this.organization.status == '2' || this.organization.status == '3') 
                && this.organization.type == '2') {
                return true
            }
            return false
        },
        isUserEdit() {
            if ((this.organization.status == '1' || this.organization.status == '4') 
                && this.organization.type == '3') {
                return true
            }
            return false
        },
        isUserReadonly() {
            if ((this.organization.status == '2' || this.organization.status == '3') 
                && this.organization.type == '3') {
                return true
            }
            return false
        },
        isReadonly() {
            return (this.organization.status == '2' || this.organization.status == '3')
        },
        isOrganizationTypeReadonly() {
            return (this.organization.status != '1')
        },
        organizationTypeField() {
            return organizationAuthentication.getOrganizationTypeLabel(this.organization.type)
        },
        minDateField() {
            const currentYear = (new Date).getFullYear()
            return new Date(currentYear - 31, 0, 1)
        },
        maxDateField() {
            const currentYear = (new Date).getFullYear()
            return new Date(currentYear + 31, 0, 1)
        },
        authenticationStatusLabel() {
            if (this.organization.status == '4' && this.organization.failedMsg) {
                return this.locale['authentication-failed-reason'] + this.organization.failedMsg
            }
            return ''
        }
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        authentication(value) {
            console.log('watch authentication', value)
            for (let p in value) {
                this.organization[p] = value[p]
            }
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSubmitBtnClick() {
            let data = {
                id: this.organization.id,
                type: this.organization.type,
                status: this.organization.status
            }
            if (!this.validateSubmitRequired()) {
                if (this.organization.type == '1') {
                    if (!(this.organization.businessLicencePic || this.organization.businessLicencePicUrl)) {
                        Toast(this.locale['business-licence-pic-required'])
                    }
                    else if (!this.organization.businessFullName) {
                        Toast(this.locale['organization-fullname-required'])
                    }
                    else if (!this.organization.businessLicenceCode) {
                        Toast(this.locale['business-licence-code-required'])
                    }
                    else if (!this.organization.businessLicenceStartDate) {
                        Toast(this.locale['business-licence-start-date-required'])
                    }
                    else if (!this.organization.businessLicenceEndDate) {
                        Toast(this.locale['business-licence-end-date-required'])
                    }
                }
                else if (this.organization.type == '2') {
                    if (!this.organization.credentialType) {
                        Toast(this.locale['credential-type-required'])
                    }
                    else if (!(this.organization.credentialPic || this.organization.credentialPicUrl)) {
                        Toast(this.locale['credential-pic-required'])
                    }
                    else if (!this.organization.credentialFullName) {
                        Toast(this.locale['organization-fullname-required'])
                    }
                    else if (!this.organization.credentialCode) {
                        Toast(this.locale['credential-code-required'])
                    }
                    else if (!this.organization.credentialStartDate) {
                        Toast(this.locale['credential-start-date-required'])
                    }
                    else if (!this.organization.credentialEndDate) {
                        Toast(this.locale['credential-end-date-required'])
                    }
                    else if (!this.organization.credentialRegistrationAddress) {
                        Toast(this.locale['credential-registration-address-required'])
                    }
                }
                else if (this.organization.type == '3') {
                    if (!(this.organization.userFacePhotoPic || this.organization.userFacePhotoPicUrl)) {
                        Toast(this.locale['user-face-photo-pic-required'])
                    }
                    else if (!(this.organization.userNationalEmblemPic || this.organization.userNationalEmblemPicUrl)) {
                        Toast(this.locale['user-national-emblem-pic-required'])
                    }
                    else if (!this.organization.userFullName) {
                        Toast(this.locale['user-fullname-required'])
                    }
                    else if (!this.organization.userIndentityCode) {
                        Toast(this.locale['user-identity-code-required'])
                    }
                    else if (!this.organization.userPhone) {
                        Toast(this.locale['phone-number-required'])
                    }
                }
                else {
                    Toast(this.locale['organization-type-required'])
                }
            }
            else {
                if (this.organization.type == '1') {
                    data.businessFullName = this.organization.businessFullName
                    data.businessLicencePic = this.organization.businessLicencePic
                    data.businessLicencePicUrl = this.organization.businessLicencePicUrl
                    data.businessLicenceCode = this.organization.businessLicenceCode
                    data.businessLicenceStartDate = this.organization.businessLicenceStartDate
                    data.businessLicenceEndDate = this.organization.businessLicenceEndDate
                }
                else if (this.organization.type == '2') {
                    data.credentialType = this.organization.credentialType
                    data.credentialFullName = this.organization.credentialFullName
                    data.credentialPic = this.organization.credentialPic
                    data.credentialPicUrl = this.organization.credentialPicUrl
                    data.credentialCode = this.organization.credentialCode
                    data.credentialStartDate = this.organization.credentialStartDate
                    data.credentialEndDate = this.organization.credentialEndDate
                    data.credentialRegistrationAddress = this.organization.credentialRegistrationAddress
                }
                else if (this.organization.type == '3') {
                    data.userFullName = this.organization.userFullName
                    data.userFacePhotoPic = this.organization.userFacePhotoPic
                    data.userFacePhotoPicUrl = this.organization.userFacePhotoPicUrl
                    data.userNationalEmblemPic = this.organization.userNationalEmblemPic
                    data.userNationalEmblemPicUrl = this.organization.userNationalEmblemPicUrl
                    data.userIndentityCode = this.organization.userIndentityCode
                    data.userPhone = this.organization.userPhone
                }
                this.$emit('submit-data', data)
            }
        },
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.organization.type == '1') {
                if (this.organization.businessFullName 
                    && (this.organization.businessLicencePicUrl || this.organization.businessLicencePic)
                    && this.organization.businessLicenceCode
                    && this.organization.businessLicenceStartDate
                    && this.organization.businessLicenceEndDate) {
                    return true
                }
            }
            else if (this.organization.type == '2') {
                if (this.organization.credentialType 
                    && this.organization.credentialFullName 
                    && (this.organization.credentialPicUrl || this.organization.credentialPic)
                    && this.organization.credentialCode
                    && this.organization.credentialStartDate
                    && this.organization.credentialEndDate
                    && this.organization.credentialRegistrationAddress) {
                    return true
                }
            }
            else if (this.organization.type == '3') {
                if (this.organization.userFullName 
                    && (this.organization.userFacePhotoPicUrl || this.organization.userFacePhotoPic)
                    && (this.organization.userNationalEmblemPicUrl || this.organization.userNationalEmblemPic)
                    && this.organization.userIndentityCode
                    && this.organization.userPhone) {
                    return true
                }
            }
            return false
        },
        onTypeDataChange(data) {
            console.log('onTypeDataChange', data)
            this.organization.type = data.value
        },
        onBusinessLicencePicUploaderDataChange(data) {
            console.log('onBusinessLicencePicUploaderDataChange', data)
            this.organization.businessLicencePic = data
        },
        onBusinessLicenceStartDateChange(data) {
            console.log('onBusinessLicenceStartDateChange', data)
            this.organization.businessLicenceStartDate = data
        },
        onBusinessLicenceEndDateChange(data) {
            console.log('onBusinessLicenceEndDateChange', data)
            this.organization.businessLicenceEndDate = data.date
        },
        onCredentialTypeDataChange(data) {
            console.log('onCredentialTypeDataChange', data)
            this.organization.credentialType = data.value
        },
        onCredentialPicUploaderDataChange(data) {
            console.log('onCredentialPicUploaderDataChange', data)
            this.organization.credentialPic = data
        },
        onCredentialStartDateChange(data) {
            console.log('onCredentialStartDateChange', data)
            this.organization.credentialStartDate = data
        },
        onCredentialEndDateChange(data) {
            console.log('onCredentialEndDateChange', data)
            this.organization.credentialEndDate = data.date
        },
        onFacePhotoPicUploaderDataChange(data) {
            console.log('onFacePhotoPicUploaderDataChange', data)
            this.organization.userFacePhotoPic = data
        },
        onNationalEmblemPicUploaderDataChange(data) {
            console.log('onNationalEmblemPicUploaderDataChange', data)
            this.organization.userNationalEmblemPic = data
        },
        onBusinessLicenceCodeInput() {
            console.log('onBusinessLicenceCodeInput')
            this.organization.businessLicenceCode = this.organization.businessLicenceCode.replace(/[^A-Za-z0-9]/g, '')
        },
        onCredentialCodeInput() {
            console.log('onCredentialCodeInput')
            this.organization.credentialCode = this.organization.credentialCode.replace(/[^A-Za-z0-9]/g, '')
        },
        onUserIndentityCodeInput() {
            console.log('onUserIndentityCodeInput')
            this.organization.userIndentityCode = this.organization.userIndentityCode.replace(/[^X0-9]/g, '')
        },
        onUserPhoneInput() {
            console.log('onUserPhoneInput')
            if (this.organization.userPhone.length > 0 && this.organization.userPhone.charAt(0) != '1') {
                this.organization.userPhone = ''
            }
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
             console.log('adjustImageSize', img, w, h, QNImageUtil.imageView(img, w, h))
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
    },
}
</script>

<template>
    <div class="organization-authencation-info">
        <van-cell-group>
            <van-cell 
                :title="locale['authentication-status']"
                :label="authenticationStatusLabel"
            >
                <template #default>
                    <div class="hp100 vertical-center justify-right">
                        <img class="vertical-center" v-if="organization.status == '1'" src="@/assets/org/auth-status-init-icon.svg"/>
                        <img v-else-if="organization.status == '2'" src="@/assets/org/auth-status-checking-icon.svg"/>
                        <img v-else-if="organization.status == '3'" src="@/assets/org/auth-status-passed-icon.svg"/>
                        <img v-else-if="organization.status == '4'" src="@/assets/org/auth-status-failed-icon.svg"/>
                    </div>
                </template>
            </van-cell>
        </van-cell-group>
        <div class="u-outer-padding">
            <span class="minor-text minor-color">{{ locale['authentication-info'] }}</span>
        </div>
        <picker-selector
            v-if="!isOrganizationTypeReadonly"
            :label="locale['organization-type']"
            :options="organizationTypeOptions"
            :value="organization.type"
            @change-data="onTypeDataChange"
        />
        <van-cell
            v-else
            :title="locale['organization-type']"
            :value="organizationTypeField"
        />
        <div v-if="isTypeEmpty" class="auth-intro u-outer-padding minor-text minor-color">
            <span class="block">{{ locale['authentication-intro'] }}</span>
            <span class="block">{{ locale['authentication-intro-line-1'] }}</span>
            <span class="block text-indent-18">{{ locale['authentication-intro-line-2'] }}</span>
            <span class="block text-indent-18">{{ locale['authentication-intro-line-3'] }}</span>
            <span class="block text-indent-18">{{ locale['authentication-intro-line-4'] }}</span>
            <span class="block text-indent-18">{{ locale['authentication-intro-line-5'] }}</span>
            <span class="block">{{ locale['authentication-intro-line-6'] }}</span>
        </div>
        <van-cell-group v-else-if="isBusinessEdit">
            <image-uploader
                :label="locale['business-licence-pic-label']"
                :placeholderUrl="require('../../assets/org/business-licence-pic.png')"
                placeholderImageWidth="100px"
                placeholderImageHeight="106px"
                :oversizeMax="5000*1024"
                :oversizeHint="locale['upload-image-oversize']"
                :imageUrl="adjustImageSize(this.organization.businessLicencePicUrl, 400, 400)"
                @change-data="onBusinessLicencePicUploaderDataChange"
            />
            <van-field 
                name="business-fullname" 
                v-model="organization.businessFullName" 
                :label="locale['organization-fullname-label']" :placeholder="locale['organization-fullname-label']"
                center
                clearable
                input-align="right"
                type="textarea"
                rows="1"
                autosize
                maxlength="255" 
            />
            <van-field 
                name="business-licence-code" 
                v-model="organization.businessLicenceCode" 
                :label="locale['business-licence-code-label']" 
                :placeholder="locale['business-licence-code-label']"
                clearable
                input-align="right"
                maxlength="18"
                @input="onBusinessLicenceCodeInput"
            />
            <date-selector
                :label="locale['business-licence-start-date-label']"
                :value="organization.businessLicenceStartDate"
                :min-date="minDateField"
                :max-date="maxDateField"
                @change-data="onBusinessLicenceStartDateChange"
            />
            <shortcut-date-selector 
                :label="locale['business-licence-end-date-label']"
                :baseDate="organization.businessLicenceStartDate"
                :value="organization.businessLicenceEndDate"
                :disabled="!organization.businessLicenceStartDate"
                @change-data="onBusinessLicenceEndDateChange"
            />
        </van-cell-group>
        <van-cell-group v-else-if="isBusinessReadonly">
            <van-cell
                :title="locale['organization-fullname-label']"
                :value="organization.businessFullName"
            />
            <van-cell
                :title="locale['business-licence-code-label']"
                :value="organization.businessLicenceCode"
            />
            <van-cell
                :title="locale['business-licence-start-date-label']"
                :value="organization.businessLicenceStartDateLabel"
            />
            <van-cell
                :title="locale['business-licence-end-date-label']"
                :value="organization.businessLicenceEndDateLabel"
            />
        </van-cell-group>
        <van-cell-group v-else-if="isCredentialEdit">
            <picker-selector
                :label="locale['credential-type']"
                :options="credentialTypeOptions"
                :value="organization.credentialType"
                @change-data="onCredentialTypeDataChange"
            />
            <image-uploader
                :label="locale['credential-pic-label']"
                :placeholderUrl="require('../../assets/org/credential-pic.png')"
                placeholderImageWidth="112px"
                placeholderImageHeight="100px"
                :oversizeMax="5000*1024"
                :oversizeHint="locale['upload-image-oversize']"
                :imageUrl="adjustImageSize(this.organization.credentialPicUrl, 400, 400)"
                @change-data="onCredentialPicUploaderDataChange"
            />
            <van-field 
                name="credential-fullname" 
                v-model="organization.credentialFullName" 
                :label="locale['organization-fullname-label']" :placeholder="locale['organization-fullname-label']"
                center
                clearable
                input-align="right"
                type="textarea"
                rows="1"
                autosize
                maxlength="255" 
            />
            <van-field 
                name="credential-code" 
                v-model="organization.credentialCode" 
                :label="locale['credential-code-label']" 
                :placeholder="locale['credential-code-label']"
                clearable
                input-align="right"
                maxlength="18"
                @input="onCredentialCodeInput"
            />
            <date-selector
                :label="locale['credential-start-date-label']"
                :value="organization.credentialStartDate"
                :min-date="minDateField"
                :max-date="maxDateField"
                @change-data="onCredentialStartDateChange"
            />
            <shortcut-date-selector 
                :label="locale['credential-end-date-label']"
                :baseDate="organization.credentialStartDate"
                :value="organization.credentialEndDate"
                :disabled="!organization.credentialStartDate"
                @change-data="onCredentialEndDateChange"
            />
            <van-field 
                name="credential-registration-address" 
                v-model="organization.credentialRegistrationAddress" 
                :label="locale['credential-registration-address-label']" :placeholder="locale['credential-registration-address-label']"
                center
                clearable
                input-align="right"
                type="textarea"
                rows="1"
                autosize
                maxlength="255" 
            />
        </van-cell-group>
        <van-cell-group v-else-if="isCredentialReadonly">
            <van-cell
                :title="locale['credential-type']"
                :value="organization.credentialTypeLabel"
            />
            <van-cell
                :title="locale['organization-fullname-label']"
                :value="organization.credentialFullName"
            />
            <van-cell
                :title="locale['credential-code-label']"
                :value="organization.credentialCode"
            />
            <van-cell
                :title="locale['credential-start-date-label']"
                :value="organization.credentialStartDateLabel"
            />
            <van-cell
                :title="locale['credential-end-date-label']"
                :value="organization.credentialEndDateLabel"
            />
            <van-cell
                :title="locale['credential-registration-address-label']"
                :value="organization.credentialRegistrationAddress"
            />
        </van-cell-group>
        <van-cell-group v-else-if="isUserEdit">
            <van-cell
                :title="locale['user-identity-type']"
                :value="locale['identity-card']"
            />
            <image-uploader
                :label="locale['user-card-pic-label']"
                :placeholderUrl="require('../../assets/org/user-face-photo-pic.png')"
                placeholderImageWidth="112px"
                placeholderImageHeight="76px"
                :oversizeMax="5000*1024"
                :oversizeHint="locale['upload-image-oversize']"
                :imageUrl="adjustImageSize(this.organization.userFacePhotoPicUrl, 400, 400)"
                @change-data="onFacePhotoPicUploaderDataChange"
            />
            <image-uploader 
                :placeholderUrl="require('../../assets/org/user-national-emblem-pic.png')"
                placeholderImageWidth="112px"
                placeholderImageHeight="76px"
                :oversizeMax="5000*1024"
                :oversizeHint="locale['upload-image-oversize']"
                :imageUrl="adjustImageSize(this.organization.userNationalEmblemPicUrl, 400, 400)"
                @change-data="onNationalEmblemPicUploaderDataChange"
            />
            <van-field 
                name="user-fullname" 
                v-model="organization.userFullName" 
                :label="locale['user-fullname-label']" 
                :placeholder="locale['user-fullname-label']"
                center
                clearable
                input-align="right"
                type="textarea"
                rows="1"
                autosize
                maxlength="255" 
            />
            <van-field 
                name="user-identity-code" 
                v-model="organization.userIndentityCode" 
                :label="locale['user-identity-code-label']" 
                :placeholder="locale['user-identity-code-label']"
                clearable
                input-align="right"
                maxlength="18"
                @input="onUserIndentityCodeInput"
            />
            <van-field 
                name="phone-number" 
                v-model="organization.userPhone" 
                :label="locale['phone-number-label']" 
                :placeholder="locale['phone-number-label']"
                type="digit"
                clearable
                input-align="right"
                maxlength="11"
                @input="onUserPhoneInput"
            />
        </van-cell-group>
        <van-cell-group v-else-if="isUserReadonly">
            <van-cell
                :title="locale['user-identity-type']"
                :value="locale['identity-card']"
            />
            <van-cell
                :title="locale['user-fullname-label']"
                :value="organization.userFullName"
            />
            <van-cell
                :title="locale['user-identity-code-label']"
                :value="organization.userIndentityCode"
            />
            <van-cell
                :title="locale['phone-number-label']"
                :value="organization.userPhone"
            />
        </van-cell-group>
        <bottom-toolbar 
            v-if="!isReadonly"
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
    </div>
</template>